import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import backgroundImage from "../images/BollywoodCasino/tableBg.jpg";
import newRoundImg from "../images/BollywoodCasino/New_Round.svg";
import welcome from "../images/BollywoodCasino/welcome.gif";
import ideal from "../images/BollywoodCasino/idle.gif";
import clapping from "../images/BollywoodCasino/clapping.gif";
import crown from "../images/BollywoodCasino/crown.png";
import closedCard from "../images/BollywoodCasino/closed-card.jpg";
import heart from "../images/cardType/heart.png";
import diamond from "../images/cardType/diamond.png";
import spade from "../images/cardType/spade.webp";
import club from "../images/cardType/club.webp";
import { cards } from "../images/index";
import useRoundLoader from "../../../api/useRoundLoader";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import GameAreaLoader from "../../Loader/GameAreaLoader";

const mapCardStringToAsset = (cardString) => {
  if (!cardString || typeof cardString !== "string") return closedCard;
  const raw = cardString.trim().toUpperCase().replace(/\.(WEBP|PNG|JPE?G|SVG)$/i, "");
  const normalized = raw;
  if (cards[normalized]) return cards[normalized];
  if (cards[`${normalized}.webp`]) return cards[`${normalized}.webp`];
  return closedCard;
};

export default function GameScreen({
  bettingClosed,
  animationTime,
  settledData,
  onStageComplete,
  remainingTime,
  socketData
}) {
  const [revealedCard, setRevealedCard] = useState(false);
const roundId = socketData?.roundId;
const settlement = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);
  const flipTimeoutRef = useRef();
  const stageFiredRef  = useRef(false);
  const flipSetRef     = useRef(false);


  const isIdle = settlement?.idle === true;
  const isClapping = settlement?.clapping === true;
  

  useEffect(() => {
    clearTimeout(flipTimeoutRef.current);

    // ── Betting open → sab reset ─────────────────────────────────────────────
    if (!bettingClosed) {
      setRevealedCard(false);
      stageFiredRef.current = false;
      flipSetRef.current    = false;
      return;
    }

    // idle === true → card closed first, flips to show drawnCard shortly after
    if (isIdle) {
      if (!flipSetRef.current) {
        flipSetRef.current = true;
        setRevealedCard(false);
        flipTimeoutRef.current = setTimeout(() => {
          setRevealedCard(true);
        }, 800);
      }
      return;
    }

    // clapping === true → winner shown with clapping gif
    if (isClapping) {
      setRevealedCard(true);

      if (!stageFiredRef.current) {
        stageFiredRef.current = true;
        setTimeout(() => {
          onStageComplete?.();
        }, 600);
      }
      return;
    }

    return () => {
      clearTimeout(flipTimeoutRef.current);
    };
  }, [bettingClosed, isIdle, isClapping, socketData, onStageComplete]);

const currentGif =
  !bettingClosed ? welcome :
  isClapping     ? clapping :
  isIdle         ? ideal :
  welcome;

  const drawnCard = settlement?.drawnCard || settledData?.data?.drawnCard;
  const outcome    = settlement?.outcome    || settledData?.data?.outcome;
  const [winnerInfo, setWinnerInfo] = useState(null);


useEffect(() => {
  if (isClapping && outcome) {
    setWinnerInfo({ outcome, drawnCard });
  }
  if (!bettingClosed) {
   
    const t = setTimeout(() => setWinnerInfo(null), 500);
    return () => clearTimeout(t);
  }
}, [isClapping, outcome, drawnCard, bettingClosed]);

  return (

   <GameAreaLoader showLoader={gameScreenLoader}>

    <div className={styles.bollywoodGameContainer}>
      <div className={styles.bollywoodMainArea}>
        <div className={styles.bollywoodVideoArea}>
          <div className={styles.bollywoodVideoContainer}>

            {/* Background Table Image */}
            <img
              src={backgroundImage}
              alt="Bollywood Casino Table"
              className={styles.bollywoodBackgroundImage}
              draggable={false}
            />

            {/* Dealer GIF Overlay */}
            <div className={styles.bollywoodGifOverlay}>
              <img
                src={currentGif}
                alt="dealer gif"
                className={styles.bollywoodGifImage}
                draggable={false}
                style={{ objectFit: "contain", zIndex: 10 }}
              />
            </div>

            {/* Cards Grid */}
            <div className={styles.bollywoodCardsContainer}>
              <div className={styles.bollywoodColumn}></div>
              <div className={styles.bollywoodColumn}></div>

              {/* Column A — Ace of Spades */}
              <div className={`${styles.bollywoodColumn} ${styles.bollywoodColumnWithBorder} ${styles.bollywoodColumnBetween}`}>
                <div className={styles.bollywoodCardRow}>
                  <span className={styles.bollywoodCardText}>A</span>
                  <img src={spade} alt="spade" className={styles.bollywoodCardIcon} />
                </div>
                <span className={styles.bollywoodColumnLabel}>A</span>
              </div>

              {/* Column B — Ace of Heart/Club/Diamond */}
              <div className={`${styles.bollywoodColumn} ${styles.bollywoodColumnWithBorder} ${styles.bollywoodColumnBetween}`}>
                <div className={styles.bollywoodCardSection}>
                  {[heart, club, diamond].map((suit, i) => (
                    <div key={i} className={styles.bollywoodCardRow}>
                      <span className={styles.bollywoodCardText}>A</span>
                      <img src={suit} alt="suit" className={styles.bollywoodCardIcon} />
                    </div>
                  ))}
                </div>
                <span className={styles.bollywoodColumnLabel}>B</span>
              </div>

              {/* Column C — K/Q/J of Spades */}
              <div className={`${styles.bollywoodColumn} ${styles.bollywoodColumnWithBorder} ${styles.bollywoodColumnBetween}`}>
                <div className={styles.bollywoodCardSection}>
                  {["K", "Q", "J"].map((rank) => (
                    <div key={rank} className={styles.bollywoodCardRow}>
                      <span className={styles.bollywoodCardText}>{rank}</span>
                      <img src={spade} alt="spade" className={styles.bollywoodCardIcon} />
                    </div>
                  ))}
                </div>
                <span className={styles.bollywoodColumnLabel}>C</span>
              </div>

              {/* Column D — King of Diamond/Club */}
              <div className={`${styles.bollywoodColumn} ${styles.bollywoodColumnWithBorder} ${styles.bollywoodColumnBetween}`}>
                <div className={styles.bollywoodCardSection}>
                  {[diamond, club].map((suit, i) => (
                    <div key={i} className={styles.bollywoodCardRow}>
                      <span className={styles.bollywoodCardText}>K</span>
                      <img src={suit} alt="suit" className={styles.bollywoodCardIcon} />
                    </div>
                  ))}
                </div>
                <span className={styles.bollywoodColumnLabel}>D</span>
              </div>

              {/* Column E — K of Heart + Q of Club/Diamond/Heart */}
              <div className={`${styles.bollywoodColumn} ${styles.bollywoodColumnWithBorder} ${styles.bollywoodColumnBetween}`}>
                <div className={styles.bollywoodCardSection}>
                  <div className={styles.bollywoodCardRow}>
                    <span className={styles.bollywoodCardText}>K</span>
                    <img src={heart} alt="heart" className={styles.bollywoodCardIcon} />
                  </div>
                  {[club, diamond, heart].map((suit, i) => (
                    <div key={i} className={styles.bollywoodCardRow}>
                      <span className={styles.bollywoodCardText}>Q</span>
                      <img src={suit} alt="suit" className={styles.bollywoodCardIcon} />
                    </div>
                  ))}
                </div>
                <span className={styles.bollywoodColumnLabel}>E</span>
              </div>

              {/* Column F — J of Heart/Club/Diamond */}
              <div className={`${styles.bollywoodColumn} ${styles.bollywoodColumnWithBorder} ${styles.bollywoodColumnBetween}`}>
                <div className={styles.bollywoodCardSection}>
                  {[heart, club, diamond].map((suit, i) => (
                    <div key={i} className={styles.bollywoodCardRow}>
                      <span className={styles.bollywoodCardText}>J</span>
                      <img src={suit} alt="suit" className={styles.bollywoodCardIcon} />
                    </div>
                  ))}
                </div>
                <span className={styles.bollywoodColumnLabel}>F</span>
              </div>

              {/* Drawn Card */}
              <div className={styles.bollywoodColumn}>
                <img
                  src={
                    revealedCard && drawnCard
                      ? mapCardStringToAsset(drawnCard)
                      : closedCard
                  }
                  alt="Drawn Card"
                  className={styles.bollywoodCardImage}
                  draggable={false}
                />
              </div>

              <div className={styles.bollywoodColumn}></div>
              <div className={styles.bollywoodColumn}></div>
            </div>

            {/* Winner Animation — sirf clapping mein */}
            {bettingClosed && isClapping && outcome && (
              <div className={styles.bollywoodWinnerAnimation}>
                <img src={crown} alt="Winner Crown" className={styles.bollywoodCrownImage} />
                <span className={styles.bollywoodWinnerText}>
                  Winner: {outcome.split(",")[0]}
                </span>
              </div>
            )}

          </div>
        </div>
      </div>
      {processingLoader && (
  <div className="dataProcessingOverlay">
    <div className="cardSpinner" />
  </div>
)}
    </div>
    </GameAreaLoader>
  );
}